
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from '../utils/auth';
import { api } from '../services/api';

export default function ProtectedRoute({ children }) {
    const token = localStorage.getItem('token');
    const [authChecked, setAuthChecked] = useState(false);
    const [authValid, setAuthValid] = useState(true);

    // If no token or invalid (including 10-min expiry), redirect immediately
    if (!isTokenValid(token)) {
        clearAllUserData();
        return <Navigate to="/" replace />;
    }

    useEffect(() => {
        let cancelled = false;
        let abortController = new AbortController();
        async function checkAuth() {
            try {
                await api.get('/auth/me', { signal: abortController.signal });
                if (!cancelled) {
                    setAuthChecked(true);
                    setAuthValid(true);
                }
            } catch {
                clearAllUserData();
                if (!cancelled) {
                    setAuthValid(false);
                    setAuthChecked(true);
                }
            }
        }
        checkAuth();
        return () => {
            cancelled = true;
            abortController.abort();
        };
    }, []);

    if (!authChecked) {
        // Block all API/data rendering while checking auth
        return <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><span>Kontrollerer login…</span></div>;
    }
    if (!authValid) {
        return <Navigate to="/" replace />;
    }
    return children;
}

// Utility to clear all user data and caches
function clearAllUserData() {
    try {
        localStorage.clear();
        sessionStorage.clear();
        // Attempt to clear any caches (for service workers/PWA)
        if (window.caches && caches.keys) {
            caches.keys().then(keys => keys.forEach(key => caches.delete(key)));
        }
    } catch (e) {
        // Ignore errors
    }
}